function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Tool-call attrs (`setAttrs`' `attrs`, `wrap`/`wrapNode`'s `wrapperAttrs`) are typed as records,
 * but the payloads they arrive in encode them as a JSON string (`"{\"panelType\":\"warning\"}"`).
 * ProseMirror computes attrs from the names the node spec declares, so a string — or the
 * char-indexed object spreading one produces — contributes none of them: the requested attrs are
 * lost, every one of them falling back to whatever the caller's own fallback is, and nothing is
 * thrown to make that visible.
 *
 * Deserialise only. The attrs are passed on as they were sent, for any node type: what a given
 * attr is allowed to hold is the schema's business, not this function's.
 *
 * Returns `undefined` when there is nothing usable to apply, leaving the fallback to the caller.
 */
export function parseToolCallAttrs(attrs: unknown): Record<string, unknown> | undefined {
	if (isRecord(attrs)) {
		return attrs;
	}
	if (typeof attrs !== 'string') {
		return undefined;
	}
	try {
		const parsed: unknown = JSON.parse(attrs);
		return isRecord(parsed) ? parsed : undefined;
	} catch {
		return undefined;
	}
}
